<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="teamwidget__background module__background"
        >
        </app-modulebackground>
        <div
            class="teamwidget__container module__container"
            v-bind:class="{
                container__boxed: [1, 2].includes(module.layout.type),
                container__fluid: [3, 4].includes(module.layout.type),
                'container__boxed--half': [5, 6].includes(module.layout.type)
            }"
        >
            <div class="teamwidget__inner module__inner">
                <div
                    class="teamwidget__inner--main module__inner--main"
                    v-bind:class="{
                        'calc-padding--left': [3].includes(module.layout.type),
                        'calc-padding--right': [4].includes(module.layout.type)
                    }"
                >
                    <div
                        class="teamwidget__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="teamwidget__inner-col module__inner-col">
                            <div class="teamwidget__header module__header">
                                <h2
                                    class="teamwidget__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="teamwidget__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="teamwidget__inner-row module__inner-row">
                        <div class="teamwidget__inner-col module__inner-col">
                            <div class="teamwidget__content-block module__content-block">
                                <div
                                    class="teamwidget__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="teamwidget__inner-row module__inner-row">
                                        <div class="teamwidget__inner-col module__inner-col">
                                            <div
                                                class="teamwidget__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="teamwidget__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="
                                        items &&
                                            [1, 2, 5, 6].includes(module.layout.type) &&
                                            Array.isArray(items) &&
                                            items.length > 0
                                    "
                                >
                                    <div class="teamwidget__inner-row module__inner-row">
                                        <div class="teamwidget__inner-col module__inner-col">
                                            <div
                                                v-if="
                                                    items &&
                                                        [1, 2, 5, 6].includes(module.layout.type)
                                                "
                                                ref="slider"
                                                class="teamwidget__images"
                                                per-page="4"
                                                per-page-lg="3"
                                                per-page-md="2"
                                                per-page-sm="1"
                                                v-bind:class="{
                                                    slider:
                                                        [1, 2].includes(module.layout.type) &&
                                                        items.length > 4
                                                }"
                                            >
                                                <ul class="teamwidget__list module__list">
                                                    <li
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                        class="teamwidget__list-item module__list-item col__width--full border-color-highlighted font-bold"
                                                    >
                                                        <div
                                                            class="teamwidget__teaser-box"
                                                            v-bind:class="{
                                                                'module__teaser-box--horizontal': [
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5,
                                                                    6
                                                                ].includes(module.layout.type)
                                                            }"
                                                        >
                                                            <component
                                                                :is="
                                                                    getPageUrlFromType('team')
                                                                        ? 'a'
                                                                        : 'span'
                                                                "
                                                                v-on:click.prevent="
                                                                    scrollInsideEditor
                                                                "
                                                                v-bind:href="
                                                                    getPageUrlFromType('team')
                                                                        ? getPageUrlFromType(
                                                                              'team'
                                                                          ) +
                                                                          '/#' +
                                                                          items__value.id
                                                                        : null
                                                                "
                                                                v-bind:class="{
                                                                    'teamwidget__teaser-box-inner module__teaser-box-inner flex--wrap font-bold module__link': [
                                                                        1,
                                                                        2,
                                                                        3,
                                                                        4,
                                                                        5,
                                                                        6
                                                                    ].includes(module.layout.type)
                                                                }"
                                                            >
                                                                <div
                                                                    v-if="
                                                                        [5, 6].includes(
                                                                            module.layout.type
                                                                        )
                                                                    "
                                                                    class="teamwidget__team-item-title flex--wrap font-bold"
                                                                >
                                                                    <span
                                                                        class="teamwidget__team-item-name"
                                                                        >{{
                                                                            items__value.data.name
                                                                        }}</span
                                                                    >
                                                                    <span
                                                                        class="teamwidget__team-item-icon font-bold"
                                                                        >»</span
                                                                    >
                                                                </div>
                                                                <app-moduleimage
                                                                    v-if="
                                                                        [1, 2].includes(
                                                                            module.layout.type
                                                                        )
                                                                    "
                                                                    :data="items__value.data.image"
                                                                    :tag="'img'"
                                                                    :custom-class="
                                                                        'teamwidget__team-item-image module__image'
                                                                    "
                                                                >
                                                                </app-moduleimage>
                                                            </component>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="teamwidget__inner-row module__inner-row"
                        v-if="getPageUrlFromType('team')"
                    >
                        <div class="teamwidget__inner-col module__inner-col">
                            <div class="teamwidget__cta module__cta">
                                <app-modulebutton
                                    :href="getPageUrlFromType('team')"
                                    :custom-class="
                                        'teamwidget__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                    >Erfahren Sie mehr
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="teamwidget__inner--image module__inner--image"
                    v-if="
                        [3, 4].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[3, 4].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'teamwidget__moduleimage module__moduleimage'"
                    >
                    </app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {
        ...mapActions(['scrollInsideEditor'])
    },
    computed: {
        ...mapGetters(['getListItems', 'getPageUrlFromType']),
        items() {
            return this.getListItems('deha.user.misc.team');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
